import { EditButton, useRecordContext } from "react-admin";
import { BtnSpecialProps } from "./BtnProps";
import validatePermissions from "../validatePermissions";
import sacopModules from "../../utilities/sacopModules";

const CoreEditButton = ({ actionModule, ...props }: BtnSpecialProps) => {
    const isValid = validatePermissions(props.permission)
    const record = useRecordContext();
    let buttonContent;

    if (!record) return null;

    switch (actionModule) {
        case sacopModules.REQUESTFORACTION:
            buttonContent = (
                isValid ? <EditButton {...props} disabled={record.sendToResponsibleForAnalysis} label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
        case sacopModules.ANALYSISFORSHARES:
            buttonContent = (
                isValid ? <EditButton {...props} disabled={record.sendToResponsibleForImplementation} label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
        case sacopModules.IMPLEMENTATIONFORACTION:
            buttonContent = (
                isValid ? <EditButton {...props} disabled={record.sendToResponsibleForClosingOfActions} label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
        case sacopModules.CLOSINGFORSHARES:
            const validateClosing = Boolean(record.sendToResponsibleForVerificationEffectivenessAction);
            buttonContent = (
                isValid ? <EditButton {...props} disabled={validateClosing} label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
        case sacopModules.VERIFICATIONEFFECTIVENESSACTION:
            console.log('record', record);
            const validateVerification = Boolean(record.annulled || record.rejected || record.approved || record.closed);
            buttonContent = (
                isValid ? <EditButton {...props} /* disabled={validateVerification} */ label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
        case sacopModules.MASTEROFSHARES:
            const validateMaster = Boolean(record.annulled || record.rejected);
            buttonContent = (
                isValid ? <EditButton {...props} disabled={validateMaster} label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
        case sacopModules.NONE:
        default:
            buttonContent = (
                isValid ? <EditButton {...props} label={typeof props.label === 'string' ? props.label : undefined} /> : null
            );
            break;
    }

    return buttonContent;
}

export default CoreEditButton;

